export default function formatNumber(value: number, fraction?: number): string {
  return new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: fraction ? fraction : 2,
    maximumFractionDigits: fraction ? fraction : 2,
  }).format(value);
}
